import { AfterViewChecked, Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { CancelIconComponent } from './components/icons/cancel-icon/cancel-icon.component';
import { EVENT_NAMES } from '../shared/constants/event-names';
import { filter } from 'rxjs';
import { initFlowbite } from 'flowbite';
import { SwPartNumberService } from './services/sw-part-number.service';
import { AppInsightsService } from './services/app-insights.service';
import { UnsavedChangesModalComponent } from './components/modals/unsaved-changes-modal/unsaved-changes-modal.component';
import { AgentActionDirective } from './directives/agent-action.directive';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    HeaderComponent,
    RouterModule,
    NgxSpinnerComponent,
    CancelIconComponent,
    UnsavedChangesModalComponent,
    AgentActionDirective,
  ],
})
export class AppComponent implements OnInit, AfterViewChecked {
  public title = 'AEDBIS';

  private router = inject(Router);
  private routeRendered = false;
  private swPartNumberService = inject(SwPartNumberService);
  private appInsightsService = inject(AppInsightsService);

  public async ngOnInit(): Promise<void> {
    await this.swPartNumberService.initSwPartNumbers();
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.routeRendered = false;
      this.appInsightsService.logPageView(event.urlAfterRedirects, event.url);
    });
  }

  public abort(): void {
    document.dispatchEvent(new Event(EVENT_NAMES.ABORT_REQUEST));
  }

  public ngAfterViewChecked(): void {
    if (!this.routeRendered) {
      this.routeRendered = true;
      initFlowbite();
    }
  }
}
